"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInternalGraphQLUrl = exports.defaultGraphQLUrl = exports.authorize = exports.endgameExperimentAllocation = exports.cheggDigitalPricingBFFGraphQLUrl = exports.checkoutBffInternalUrl = exports.digitalPricingBffInternalUrl = exports.cheggCheckoutBffGraphQLUrl = exports.cheggGraphQLUrl = exports.cheggOrigin = exports.cheggBaseUrl = exports.authorizeParams = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
var authorize = function (payload) {
    var _a, _b;
    if (!payload.apiKey) {
        return {
            data: {},
            errors: [constants_1.AuthorizeErrors.MISSING_API_KEY],
            success: false,
        };
    }
    payload.bffKey = (_a = payload.bffKey) !== null && _a !== void 0 ? _a : payload.apiKey;
    exports.authorizeParams = tslib_1.__assign(tslib_1.__assign({}, payload), (!payload.csrfToken && { noCookie: 1 }));
    exports.cheggBaseUrl = payload.cheggBaseUrl || "";
    if (payload.cheggGraphQLUrl) {
        try {
            // sanitize cheggGraphQLUrl in case client is passing bad params
            exports.cheggGraphQLUrl = new URL(payload.cheggGraphQLUrl).origin;
            // trailing forward slash needed bc origin does not include it
            exports.cheggGraphQLUrl = exports.cheggGraphQLUrl + "/";
        }
        catch (_c) {
            exports.cheggGraphQLUrl = (0, exports.defaultGraphQLUrl)(exports.cheggBaseUrl);
        }
    }
    else {
        exports.cheggGraphQLUrl = (0, exports.defaultGraphQLUrl)(exports.cheggBaseUrl);
    }
    exports.digitalPricingBffInternalUrl =
        payload.internalGraphQLUrl || (0, exports.defaultInternalGraphQLUrl)(exports.cheggBaseUrl);
    exports.checkoutBffInternalUrl = exports.digitalPricingBffInternalUrl
        ? exports.digitalPricingBffInternalUrl.replace("digital-pricing-bff", "checkout-bff")
        : exports.checkoutBffInternalUrl;
    exports.cheggDigitalPricingBFFGraphQLUrl = "".concat(exports.cheggGraphQLUrl, "digital-pricing-bff/graphql");
    exports.cheggCheckoutBffGraphQLUrl = "".concat(exports.cheggGraphQLUrl, "checkout-bff/graphql");
    exports.cheggOrigin = (_b = payload.origin) !== null && _b !== void 0 ? _b : "";
    exports.endgameExperimentAllocation = payload.endgameExperimentAllocation || "phase2";
    return { success: true, data: {}, errors: null };
};
exports.authorize = authorize;
var defaultGraphQLUrl = function (url) {
    return url.match(/^http[s]?:\/\/[a-zA-Z0-9.-]*chegg.com((:[0-9]+)?\/?)?$/)
        ? constants_1.BFF_GATEWAY_PRODUCTION_URL
        : constants_1.BFF_GATEWAY_TEST_URL;
};
exports.defaultGraphQLUrl = defaultGraphQLUrl;
var defaultInternalGraphQLUrl = function (url) {
    return url.match(/^http[s]?:\/\/[a-zA-Z0-9.-]*chegg.com((:[0-9]+)?\/?)?$/)
        ? constants_1.BFF_INTERNAL_PRODUCTION_URL
        : constants_1.BFF_INTERNAL_TEST_URL;
};
exports.defaultInternalGraphQLUrl = defaultInternalGraphQLUrl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/authorize/index.js
// module id = 330
// module chunks = 11